import React from "react";
import { useI18n } from "@/lib/i18n";

/**
 * Databridgar mark: a bridge glyph (two piers + arc + deck) with three amber
 * connection nodes. Built inline so it stays crisp and needs no network round-trip.
 */
export const LogoMark = ({ className = "h-9 w-9", title }) => (
  <svg
    viewBox="0 0 44 40"
    className={className}
    role="img"
    aria-label={title || "Databridgar"}
  >
    <g
      fill="none"
      stroke="#0B1220"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 34V22" />
      <path d="M36 34V22" />
      <path d="M8 22C8 11.5 36 11.5 36 22" />
      <path d="M4 25.5h36" />
      <path d="M15 25.5v-5.4" />
      <path d="M29 25.5v-5.4" />
    </g>
    <circle cx="15" cy="18.4" r="2.1" fill="#D79A2B" />
    <circle cx="22" cy="14.6" r="2.6" fill="#D79A2B" />
    <circle cx="29" cy="18.4" r="2.1" fill="#D79A2B" />
  </svg>
);

export const Logo = ({ compact = false, className = "" }) => {
  const { t } = useI18n();
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark className="h-9 w-9 shrink-0" title={t("common.logoAlt")} />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="text-[1.05rem] font-semibold tracking-[-0.01em] text-ink">
            {t("common.brand")}
          </span>
          <span className="mt-[3px] hidden font-mono text-[0.56rem] uppercase tracking-[0.18em] text-muted-ink/70 sm:block">
            {t("header.eyebrow")}
          </span>
        </span>
      )}
    </span>
  );
};
